import { render, staticRenderFns } from "./EditorSection.vue?vue&type=template&id=6aa852b8&"
import script from "./EditorSection.vue?vue&type=script&lang=ts&"
export * from "./EditorSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports